import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SavedGroupsService } from '../../services/orders/saved-groups.service';

export interface GroupAssignDialogData {
  groups: Array<{ gid: string; name: string; color?: string }>;
  uuid: string;
  newColor?: string;
}

export interface GroupAssignDialogResult {
  kind: 'existing' | 'new';
  gid?: string;
}

@Component({
  selector: 'app-group-assign-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <div class="dialog-container">
      <h2 class="title">Agregar a grupo</h2>

      <div class="section">
        <div class="subtitle">Selecciona un grupo existente</div>
        <div class="groups-list">
          <button
            class="group-card"
            *ngFor="let g of data.groups"
            type="button"
            (click)="selectExisting(g.gid)"
            [class.selected]="selectedKind === 'existing' && selectedGid === g.gid"
          >
            <span class="color-dot" [style.background]="g.color || '#999'"></span>
            <span class="group-name">{{ g.name }}</span>
          </button>
          <button
            class="group-card new"
            type="button"
            (click)="selectNew()"
            [class.selected]="selectedKind === 'new'"
          >
            <span class="new-dot" [style.background]="data.newColor || '#8EC5FC'"></span>
            <span class="group-name">Nuevo grupo</span>
          </button>
        </div>
      </div>

      <div class="actions">
        <button mat-stroked-button (click)="close()" [disabled]="isSaving">Cancelar</button>
        <button mat-flat-button color="primary" (click)="save()" [disabled]="!selectedKind || isSaving">
          {{ isSaving ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .dialog-container { padding: 16px 16px 12px; width: 380px; max-width: 100%; }
      .title { margin: 0 0 12px; font-size: 18px; font-weight: 600; }
      .section { margin-bottom: 12px; }
      .subtitle { font-size: 14px; color: #666; margin-bottom: 8px; }
      .groups-list { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
      .group-card {
        display: flex; align-items: center; gap: 8px;
        padding: 10px 12px; border-radius: 8px; border: 1px solid #e4e4e4;
        background: #fff; cursor: pointer; outline: none;
      }
      .group-card:active { transform: scale(0.99); }
      .group-card.selected { border-color: #2d7ff9; box-shadow: 0 0 0 2px rgba(45,127,249,0.15); }
      .group-card.new .new-dot { width: 14px; height: 14px; border-radius: 50%; display: inline-block; background: linear-gradient(135deg, #8EC5FC 0%, #E0C3FC 100%); }
      .color-dot { width: 14px; height: 14px; border-radius: 50%; display: inline-block; }
      .group-name { font-size: 14px; color: #333; }
      .actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 8px; }
      .actions button { min-width: 110px; }
    `,
  ],
})
export class GroupAssignDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GroupAssignDialogData,
    private dialogRef: MatDialogRef<GroupAssignDialogComponent, GroupAssignDialogResult>,
    private savedGroupsService: SavedGroupsService,
  ) {}

  selectedKind: 'existing' | 'new' | undefined;
  selectedGid: string | undefined;
  isSaving = false;

  selectExisting(gid: string) {
    this.selectedKind = 'existing';
    this.selectedGid = gid;
  }

  selectNew() {
    this.selectedKind = 'new';
    this.selectedGid = undefined;
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    if (!this.selectedKind) return;
    if (this.selectedKind === 'existing' && this.selectedGid) {
      this.isSaving = true;
      this.savedGroupsService.addItemsToGroup(this.selectedGid, [this.data.uuid]).subscribe({
        next: () => {
          this.isSaving = false;
          this.dialogRef.close({ kind: 'existing', gid: this.selectedGid });
        },
        error: () => {
          this.isSaving = false;
        }
      });
    } else if (this.selectedKind === 'new') {
      this.dialogRef.close({ kind: 'new' });
    }
  }
}